import React from "react";
import styled from "styled-components";
import { Form, Row, Col, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaRegUser, FaRegEnvelope } from "react-icons/fa";
import { BiLockAlt } from "react-icons/bi";
import { BsEye } from "react-icons/bs";
// import history from "../history";

import { registerUser } from "./../utils/firebase/auth";

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      isSecureField: true,
      isLoading: false
    };
  }

  handleRegister = (event) => {
    event.preventDefault();
    let data = this.state;
    delete data.isSecureField;
    this.setState({ isLoading: true });
    let stopLoading = () => {
      this.setState({ isLoading: false });
    };
    registerUser(data, stopLoading).then(() => {
      localStorage.setItem("isSignup", true);
      localStorage.setItem("isAccount", true);
      window.location.href = "/signin";
    });
  };

  render() {
    // const [isSecureField, setType] = useState(true);

    return (
      <div className="sign">
        <Form>
          <H5>Get Started</H5>
          <H2>Join</H2>
          <Row>
            <Col className="m-2">
              <InputGroup>
                <InputGroup.Prepend>
                  <FaRegUser
                    size={18}
                    style={{
                      position: "relative",
                      top: "16px",
                      marginRight: "1px",
                    }}
                  />
                </InputGroup.Prepend>
                <Form.Control
                  placeholder="First Name"
                  value={this.state.first_name}
                  onChange={(newValue) => {
                    this.setState({
                      first_name: newValue.target.value,
                    });
                  }}
                />
              </InputGroup>
            </Col>
            <Col className="m-2">
              <InputGroup>
                <InputGroup.Prepend>
                  <FaRegUser
                    size={18}
                    style={{
                      position: "relative",
                      top: "16px",
                      marginRight: "1px",
                    }}
                  />
                </InputGroup.Prepend>
                <Form.Control
                  placeholder="Last Name"
                  value={this.state.last_name}
                  onChange={(newValue) => {
                    this.setState({
                      last_name: newValue.target.value,
                    });
                  }}
                />
              </InputGroup>
            </Col>
          </Row>
          <Row>
            <Col className="m-2">
              <InputGroup>
                <InputGroup.Prepend>
                  <FaRegEnvelope
                    size={20}
                    style={{
                      position: "relative",
                      top: "14px",
                      marginRight: "1px",
                    }}
                  />
                </InputGroup.Prepend>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={this.state.email}
                  onChange={(newValue) => {
                    this.setState({
                      email: newValue.target.value,
                    });
                  }}
                />
              </InputGroup>
            </Col>
          </Row>
          <Row>
            <Col className="m-2">
              <InputGroup>
                <InputGroup.Prepend>
                  <BiLockAlt
                    size={23}
                    style={{
                      position: "relative",
                      top: "11px",
                      marginRight: "1px",
                    }}
                  />
                </InputGroup.Prepend>
                <Form.Control
                  type={`${this.state.isSecureField ? "password" : "text"}`}
                  placeholder="Create Password"
                  value={this.state.password}
                  onChange={(newValue) => {
                    this.setState({
                      password: newValue.target.value,
                    });
                  }}
                />
                <InputGroup.Prepend>
                  <BsEye
                    size={23}
                    style={{
                      position: "relative",
                      top: "11px",
                      marginRight: "1px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      this.setState({
                        isSecureField: !this.state.isSecureField,
                      })
                    }
                  />
                </InputGroup.Prepend>
              </InputGroup>
            </Col>
          </Row>
          <Row>
            <SubmitBtn onClick={this.handleRegister} className="m-2" disabled={this.state.isLoading}>
              Join
              {this.state.isLoading && (
                <i
                  className="fa fa-spinner fa-spin fa-2xl"
                  aria-hidden="true"
                />
              )}
            </SubmitBtn>
          </Row>
          <Terms className="m-1">
            By clicking "Join" you agree to our
            <DocHref href="/" target="blank">
              {" "}
              Terms of Service{" "}
            </DocHref>{" "}
            and
            <DocHref href="/" target="blank">
              {" "}
              Privacy Policy{" "}
            </DocHref>
          </Terms>
          <Linkin className="mt-4">
            Already have an account? <Link to="/signin">Log in</Link>
          </Linkin>
        </Form>
      </div>
    );
  }
}

export default Signup;

const H5 = styled.h5`
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 1px;
  color: #b5b5be;
  text-transform: uppercase;
`;
const H2 = styled.h2`
  font-family: PoppinsMedium;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  margin-top: 20px;
  margin-bottom: 40px;
`;
const SubmitBtn = styled.button`
  width: 100%;
  font-family: PoppinsLight;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #fafafb;
  background: #01a3a4;
  border-radius: 10px;
  border: none;
  padding: 15px;
`;
const Terms = styled.p`
  text-align: center;
  font-family: RobotoLight;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #b5b5be;
`;
const Linkin = styled.p`
  text-align: center;
  font-family: PoppinsLight;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #92929d;
  a {
    color: #01a3a4;
    font-weight: 500;
    &:hover {
      color: #01a3a4;
    }
  }
`;
const DocHref = styled.a`
  color: #01a3a4;
  font-weight: 500;
  &:hover {
    color: #01a3a4;
  }
`;
